import { Util } from '@libs/utilities/util';
import { DOCUMENT } from '@angular/common';
import { EnumNgFaSize } from '@libs/frameworks/angular';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';


/**------------------------------------------------------
 * Fullscreen Component
 * --------------------
 * > Handles full screen events
 * > link: https://stackoverflow.com/questions/51998594/how-to-make-google-chrome-go-full-screen-in-angular-4-application
 */
@Component({
    selector: 'ui-fullscreen',
    templateUrl: './fullscreen.component.html',
    styleUrls: ['./fullscreen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UiFullscreenComponent {

	//** UI Variables */
	expand: boolean = false;

	//** Getter Helpers */
	readonly EnumNgFaSize: typeof EnumNgFaSize = EnumNgFaSize;


	constructor(
		@Inject(DOCUMENT)
		private document: IUiDocument
	) {}

	onFullScreenChange(): void {
		this.expand = !this.expand;
		if (this.expand) this.openFullscreen();
			else this.closeFullscreen();
	}

	//** Open fullscreen */
	openFullscreen(): void {
		const docElem: any = this.document.documentElement;
		switch (true) {

			//a. default
			case Util.Basic.isDefined(docElem.requestFullscreen):
				docElem.requestFullscreen();
				break;

			//b. firefox
			case Util.Basic.isDefined(docElem.mozRequestFullScreen):
				docElem.mozRequestFullScreen();
				break;

			//c. chrome, safari and opera
			case Util.Basic.isDefined(docElem.webkitRequestFullscreen):
				docElem.webkitRequestFullscreen();
				break;

			//d. internet explorer or edge
			case Util.Basic.isDefined(docElem.msRequestFullscreen):
				docElem.msRequestFullscreen();
				break;

			default:
				// do nothing / do not break frontend
		}
	}

	//** Close fullscreen */
	closeFullscreen(): void {
		switch (true) {

			//a. default
			case Util.Basic.isDefined(this.document.exitFullscreen):
				this.document.exitFullscreen();
				break;

			//b. firefox
			case Util.Basic.isDefined(this.document.mozCancelFullScreen):
				this.document.mozCancelFullScreen();
				break;

			//c. chrome, safari and opera
			case Util.Basic.isDefined(this.document.webkitExitFullscreen):
				this.document.webkitExitFullscreen();
				break;

			//d. internet explorer or edge
			case Util.Basic.isDefined(this.document.msExitFullscreen):
				this.document.msExitFullscreen();
				break;

			default:
				// do nothing / do not break frontend
		}
	}
}


//** Interfaces --------------------------------- */
interface IUiDocument {
	documentElement		: any; 			// eslint-disable-line @typescript-eslint/no-explicit-any
	exitFullscreen		: () => void;
	mozCancelFullScreen	: () => void;
	webkitExitFullscreen: () => void;
	msExitFullscreen	: () => void;
}
